import { BlockConfigurationObject } from "../interfaces/block-configuration-object.interface";

export class ShortlistService {
	_configurationObject: BlockConfigurationObject;

	/* @ngInject */
	constructor(configurationObject: BlockConfigurationObject) {
		this._configurationObject = configurationObject;
	}

	shortlistingAvailable(): boolean {
		if (typeof this._configurationObject.allowShortlisting != "undefined" && !this._configurationObject.allowShortlisting) {
			return false;
		}

		return true;
	}

	matchInShortlist(matchid: string): boolean {
		if (typeof this._configurationObject.shortlistCheckFunction === "function") {
			return this._configurationObject.shortlistCheckFunction(matchid);
		} else {
			return false;
		}
	}

	toggleMatchInShortlist(matchid: string): void {
		if (typeof this._configurationObject.shortlistToggleFunction === "function") {
			this._configurationObject.shortlistToggleFunction(matchid);
		}
	}
}